import { Component, forwardRef, Inject, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'uib-btn-radio-wrapper',
  templateUrl: '../app/ng1-wrappers/bootstrap-wrappers/uib-btn-radio-wrapper/uib-btn-radio-wrapper.view.html',
  styleUrls: ['../app/ng1-wrappers/bootstrap-wrappers/uib-btn-radio-wrapper/uib-btn-radio-wrapper.style.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UibBtnRadioWrapperComponent),
      multi: true
    }
  ]
})
export class UibBtnRadioWrapperComponent implements ControlValueAccessor {
  @Input() measurementStandards: any[]; // Your measurement standards input
  @Input() canUpdate: boolean;
  private onChange: Function = () => {};
  private onTouched: Function = () => {};
  selectedValue: any;

  constructor( @Inject('ViewAuthorizationFactory') private viewAuth) {}

  writeValue(value: any): void {
   this.selectedValue = value;
  }
  onSelect(value: any): void {
    this.writeValue(value); 
    this.onChange(value); 
  }

  registerOnChange(fn: Function): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }

}
